define([
	"csi/_base/underscore",
	"./_GroupUngroup",
	"./PluginFactory",
	"./util"
], function(_,_GroupUngroup, PluginFactory,util) {

	return PluginFactory.declare(_GroupUngroup, {
		iconClass: "csiActionIcon svgIconUngroup",
		pluginName: "ungroup",
		title: "CanvasUngroup",

		enablePlugin: function(/*Shape[]*/shapes, /*Object*/shapeAttrs, /*Object*/textAttrs) {
			return this.inherited(arguments) && this.editor.canvasApp.selection.canUngroupSelection();
		},

		onClick: function(/*Event*/e) {
			// summary: ungroup selected shapes
			this.editor.ungroupSelection();
		}
	});
});
